import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NotificationManager } from "react-notifications";
import "react-notifications/lib/notifications.css";
import PageContent from "./PageContent";
import LeftSidebar from "./LeftSidebar";
import { Grid, Box } from "@mui/material";
import { removeNotificationMessage } from "../store/slices/headerSlice";
import Header from "./Header";
import Loader from "./Loader"; 

function Layout() {
  const dispatch = useDispatch();
  const [collapsed, setCollapsed] = useState(true);
  const [loading, setLoading] = useState(true);

  const { newNotificationMessage, newNotificationStatus } = useSelector(
    (state) => state.header
  );
  const user = useSelector((state) => state?.users);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false); 
    }, 2000);
  }, []);

  useEffect(() => {
    if (newNotificationMessage) {
      if (newNotificationStatus === 1) {
        NotificationManager.success(newNotificationMessage, "Success");
      } else if (newNotificationStatus === 0) {
        NotificationManager.error(newNotificationMessage, "Error");
      }
      dispatch(removeNotificationMessage());
    }
  }, [newNotificationMessage, newNotificationStatus, dispatch]);

  if (loading) {
    return <Loader />;
  }

  return (
    <Grid container>
      {user.id ? (
        <>
          <Header />
          <Grid item md={collapsed ? 1 : 2} mt={"9vh"}>
            <LeftSidebar collapsed={collapsed} setCollapsed={setCollapsed} />
          </Grid>
          <Grid item md={collapsed ? 11 : 10}>
            <PageContent />
          </Grid>
        </>
      ) : (
        <Grid item xs={12}>
          <Header />
          <Box component="main" sx={{ p: 3 }}>
            <PageContent />
          </Box>
        </Grid>
      )}
    </Grid>
  );
}

export default Layout;
